import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {IncExcKey} from '../message/IncExcKey';
import {IncExcKeyCriteria} from './IncExcKeyCriteria';

export class IncExcKeyWrapper extends BaseWrapper<IncExcKey, IncExcKeyCriteria, BasicScenario>  {}

